import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import * as Styled from './styles';
import AttentionImg from 'assets/images/feedback/attention_circle_3d.png';

type AttentionHintProps = {
  text: string;
  subText?: string;
  sameLine?: boolean;
};

export const AttentionHint: FC<AttentionHintProps> = ({
  text,
  subText,
  sameLine
}) => {
  const { t } = useTranslation();

  return (
    <Styled.AttentionHintWrapper>
      <Styled.AttentionHintTopWrapper>
        <Styled.AttentionHintIcon src={AttentionImg} preview={false} />
        <Styled.AttentionHintInnerWrapper>
          <Styled.AttentionHintTextWrapper>
            <Styled.AttentionHintText $sameLine={!sameLine}>
              {t('generic.attention')}
            </Styled.AttentionHintText>
            {text}
          </Styled.AttentionHintTextWrapper>
          {subText && <Styled.AttentionText>{subText}</Styled.AttentionText>}
        </Styled.AttentionHintInnerWrapper>
      </Styled.AttentionHintTopWrapper>
    </Styled.AttentionHintWrapper>
  );
};
